export const DEFAULT_MAP_CENTER = { lat: 49.25363726536889, lng: -123.1114298669681 };
export const DEFAULT_MAP_ZOOM = 12;
